/*
 * Public API Surface of core
 */
export * from './lib/classes';
export * from './lib/components';
export * from './lib/config';
export * from './lib/core.module';
export * from './lib/enums';
export * from './lib/environments';
export * from './lib/functions';
export * from './lib/guards';
export * from './lib/helpers';
export * from './lib/interceptors';
export * from './lib/models';
export * from './lib/modules';
export * from './lib/services';
export * from './lib/store';
export * from './lib/types';

// Export API client configuration and services separately to avoid conflicts with existing enums
export { Configuration } from './lib/api-client/configuration';
export { DynamicApiConfiguration } from './lib/config/dynamic-api-configuration';
export { ApiModule } from './lib/api-client/api.module';

// Export individual shared API services
export { AdresseApiService } from './lib/api-client/api/adresse.service';
export { AffaireEditionApiService } from './lib/api-client/api/affaire-edition.service';
export { AlfrescoApiService } from './lib/api-client/api/alfresco.service';
export { AuthApiService } from './lib/api-client/api/auth.service';
export { BeneficiaireEffectifApiService } from './lib/api-client/api/beneficiaire-effectif.service';
export { CommonAlfrescoApiService } from './lib/api-client/api/common-alfresco.service';
export { CommonRessourcesApiService } from './lib/api-client/api/common-ressources.service';
export { ConfigurationApiService } from './lib/api-client/api/configuration.service';
export { DocumentApiService } from './lib/api-client/api/document.service';
export { EmailApiService } from './lib/api-client/api/email.service';
export { EntrepriseApiService } from './lib/api-client/api/entreprise.service';
export { MessageApiService } from './lib/api-client/api/message.service';
export { ModeReceptionApiService } from './lib/api-client/api/mode-reception.service';
export { PreferenceApiService } from './lib/api-client/api/preference.service';
export { ReferentielApiService } from './lib/api-client/api/referentiel.service';
export { ReferentielCarpaApiService } from './lib/api-client/api/referentiel-carpa.service';
export { RibApiService } from './lib/api-client/api/rib.service';
export { TenantRessourcesApiService } from './lib/api-client/api/tenant-ressources.service';
export { TenantUtilisateurApiService } from './lib/api-client/api/tenant-utilisateur.service';
export { TiersApiService } from './lib/api-client/api/tiers.service';
export { UtilisateurApiService } from './lib/api-client/api/utilisateur.service';
